import angular from 'angular';

import WorkflowEventsController from './events.controller';

export default angular.module('autoboard.workflowEvents', [])
  .controller('WorkflowEventsController', WorkflowEventsController)
  .name;
